import {SETTINGS} from './Settings';
// import * as modernizr from '../utils/modernizr';
// import {EventEmitter} from "eventemitter3";
import Emitter from 'eventemitter3';
import {Power4, TweenMax} from "gsap";
import './helpers/dom'


/**
 * VIEWPORT
 * Handles basic setup of screen
 * 1) Initialises events related to viewport
 * 2) Adds global loading overlay, removes it on window.loaded
 * 3) ...
 *
 * PUBLIC VARIABLES:
 * ----------------
 * small        | BOOL
 * tablet       | BOOL
 * desktop      | BOOL
 * width        | px
 * height       | px
 *
 *
 * METHODS:
 * -------
 *
 * none
 *
 * EVENTS:
 * ------
 *
 * viewport:ready
 * viewport:resize
 * orientationchange
 *
 *
 */



export default class Viewport extends Emitter {

    constructor() {
        super();

        let me = this;

        // DOM Object cache :: TODO: make dynamic by reading strings from settings object
        this.DOM = {
            overlay : '#overlay'
        };

        // fn bindings
        this._updateViewportDimensions = this._updateViewportDimensions.bind(this);
        this._onWindowResize = this._onWindowResize.bind(this);
        this._onWindowLoaded = this._onWindowLoaded.bind(this);
        this._liftLoadMask = this._liftLoadMask.bind(this);
        this._showLoadMask = this._showLoadMask.bind(this);
        this._onOrientationChange = this._onOrientationChange.bind(this);

        // Runtime vars
        this.small = false;
        this.tablet = false;
        this.desktop = false;
        this.width = null;
        this.height = null;
        this.displayHeight = null;
        this.displayWidth = null;
        this.ratio = 1;
        this.deviceOrientation = null;

        /**
         * Basic Check for Mobile
         */
        this.isMobile = {

            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function() {
                return (me.isMobile.Android() || me.isMobile.BlackBerry() || me.isMobile.iOS() || me.isMobile.Opera() || me.isMobile.Windows());
            }
        };

        // isMobile = this.isMobile.iOS();

        /**
         * Throttle Resize-triggered Events [ ]
         * ( source: http://stackoverflow.com/questions/2854407/javascript-jquery-window-resize-how-to-fire-after-the-resize-is-completed )
         *
         * @param  {Object} ) {				var     timers [description]
         * @return {[type]}   [description]
         */
        this._waitForFinalEvent = (() => {
            var timers = {};
            return function (callback, ms, uniqueId) {
                if (!uniqueId) {
                    uniqueId = "Don't call this twice without a uniqueId";
                }
                if (timers[uniqueId]) {
                    clearTimeout(timers[uniqueId]);
                }
                timers[uniqueId] = setTimeout(callback, 500);
            };
        })();


        // Trigger initial measurement
        this._onWindowResize();

        // Orientation change listener
        window.addEventListener("orientationchange", this._onOrientationChange);
        this._onOrientationChange(); // force trigger

        // Window resize listeners
        me._updateViewportDimensions();
        $(window).on('resize', this._onWindowResize);

        // Window loaded
        this.window_on_load_callbacks = [];
        this.window_on_load_callbacks.push(this._liftLoadMask);
        $(window).on('load', this._onWindowLoaded);
        // Just before page change...
        $(window).on('beforeunload', ()=>{
            this._showLoadMask();
        });
    }




    // -------------------------------------------------------
    // Private


    _onWindowLoaded() {
        let me = this;
        // Execute callbacks
        if (me.window_on_load_callbacks.length)
            $(me.window_on_load_callbacks).each(function (index, fn) {fn();});

        this.emit('viewport:ready');
    }


    /**
     * On resize, update viewport
     */
    _onWindowResize() {
        let me = this;
        // do not trigger the event every frame...
        me._waitForFinalEvent(() => {
            me._updateViewportDimensions();
            me.emit('viewport:resize');
        })
    }


    /**
     * Orientation Change Event
     * @private
     */
    _onOrientationChange() {
        let me = this;
        //
        this.emit('orientationchange', screen.orientation);
    }

    _liftLoadMask() {

        let me = this;
        if (SETTINGS.USE_LOADMASK) {
            me.emit('viewport:overlay:lifting');
            TweenMax.to(me.DOM.overlay, 2.72, {
                y: -me.height, 'display':'none', ease: Power4.easeOut, onComplete: function () {
                    // me.DOM.overlay.remove();
                    me.emit('viewport.overlay.lifted');
                }
            });
        }
    }

    _showLoadMask() {
        let me = this;
        if (SETTINGS.USE_LOADMASK) {
            TweenMax.to(me.DOM.overlay, 0.35, {
                alpha: 1, 'display':'block', ease: Power4.easeInOut, onComplete: function () {}
            });
        }
    }


    /*
  * Get Viewport Dimensions
  * returns object with viewport dimensions to match css in width and height properties
  * ( source: http://andylangton.co.uk/blog/development/get-viewport-size-width-and-height-javascript )
  */
    _updateViewportDimensions() {
        let me = this;
        var w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight,
            small, tablet, desktop;

        if (x < SETTINGS.BREAKPOINTS.small) {
            small = true;
            tablet = false;
            desktop = false;
        } else if (x > SETTINGS.BREAKPOINTS.small && x <= SETTINGS.BREAKPOINTS.tablet) {
            small = false;
            tablet = true;
            desktop = false;
        } else if (x > SETTINGS.BREAKPOINTS.tablet) {
            small = false;
            tablet = false;
            desktop = true;
        }

        //
        // observe dpi
        var realToCSSPixels = window.devicePixelRatio;
        // Lookup the size the browser is displaying the canvas in CSS pixels
        // and compute a size needed to make our drawingbuffer match it in
        // device pixels.
        // me.displayWidth  = Math.floor(this.canvas.clientWidth  * realToCSSPixels);
        // me.displayHeight = Math.floor(this.canvas.clientHeight * realToCSSPixels);


        // return {
        me.width = x;
        me.height = y;
        me.small = small;
        me.tablet = tablet;
        me.desktop = desktop
        me.ratio = me.width / me.height;


        // Orientation change
        // We use a simple viewport measurement
        if (me.width < 768 || me.width < me.height) {
            TweenMax.to('#orientationchange-overlay', 0.5, {alpha: 1, "display": "flex"});
        } else {
            TweenMax.to('#orientationchange-overlay', 0.5, {alpha: 0, "display": "none"});
        }

    }



}
